import { io } from "socket.io-client";

// autoConnect is OFF: merely importing this module must not open a connection —
// public pages (/login, /register) have no session and should stay network-silent.
// NotificationProvider calls socket.connect() once the user is authenticated;
// socket.io buffers any emit() made before the connection is up, so consumers
// (Layout, Notificationbar) don't need to care about ordering.
const socket = io(process.env.REACT_APP_SOCKET_BASE_URL || "http://localhost:4001", {
    transports: ["websocket"],
    reconnection: true,
    autoConnect: false,
});

export default socket;
